import { Image } from 'expo-image';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import Text from '@/components/Text';
import { BLUR_HASH } from '@/constants/layout';

interface SeasonMissionCardProps {
  title: string;
  subtitle?: string;
  description: string;
  image: string;
  height?: number;
  width?: number;
  onPress: () => void;
}

const SeasonMissionCard = ({ title, subtitle, description, image, height, width, onPress }: SeasonMissionCardProps) => {
  const style = useStyle(height, width);

  return (
    <TouchableOpacity onPress={onPress}>
      <View style={style.mainContainer}>
        <Image style={style.imageStyle} source={image} contentFit="cover" placeholder={{ blurhash: BLUR_HASH }} />

        <View style={style.textContainer}>
          <Text style={style.title} fontWeight="900" numberOfLines={2}>
            {title}
          </Text>

          {subtitle && (
            <Text style={style.subtitle} numberOfLines={1}>
              {subtitle}
            </Text>
          )}

          <Text style={style.description} numberOfLines={1}>
            {description}
          </Text>
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default SeasonMissionCard;

const useStyle = (height: number | undefined, width: number | undefined) => {
  const style = StyleSheet.create({
    mainContainer: {
      height: height ?? 332,
      width: width ?? '100%',
      borderRadius: 10,
      overflow: 'hidden',
      justifyContent: 'flex-end',
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.15,
      shadowRadius: 4,
      elevation: 4
    },

    imageStyle: {
      ...StyleSheet.absoluteFill
    },

    textContainer: {
      backgroundColor: 'rgba(0,0,0,0.4)',
      padding: 12,
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%'
    },

    title: {
      color: 'white',
      letterSpacing: -0.36,
      fontSize: 16,
      textAlign: 'center',
      marginBottom: 2
    },

    subtitle: {
      color: 'white',
      fontSize: 14,
      textAlign: 'center',
      marginBottom: 2
    },

    description: {
      color: 'white',
      fontSize: 14,
      textAlign: 'center'
    }
  });

  return style;
};
